import { render } from "./googleoauth.vue?vue&type=template&id=4828dec8&scoped=true"
import script from "./googleoauth.vue?vue&type=script&lang=js"
export * from "./googleoauth.vue?vue&type=script&lang=js"

import "./googleoauth.vue?vue&type=style&index=0&id=4828dec8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4828dec8"]])

export default __exports__